module.exports = __webpack_public_path__ + "img/lucky.3f370980.svg";